<template lang="pug">
.jp
  .html_content(v-html="pageData.HtmlContent")
  custom-footer
</template>

<script>
import Footer from "@/components/jp/Footer";
import { getCustomizePage } from "@/json/customize";

export default {
  name: "Japanese",
  metaInfo() {
    return {
      title: this.pageData.SEO_Title,
      meta: [{ name: "description", content: this.pageData.SEO_Description }],
    };
  },
  components: {
    "custom-footer": Footer,
  },
  data() {
    return {
      pageData: {},
    };
  },
  watch: {
    $route(to) {
      if (to.name == "Japanese") {
        if (to.params.page) {
          this.initPage(to.params.page);
        }
      }
    },
  },
  created() {
    this.initPage(this.$route.params.page);
  },
  methods: {
    initPage(JSON_NAME) {
      getCustomizePage(JSON_NAME).then((response) => {
        this.pageData = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.html_content {
  width: 100%;
  height: auto;
}
</style>
